import restAction from "../common/restAction";

const state = {
    selectedPrevQrt: null,
    selectedUnit: null,
    selectQrtInfo: {
        selectedQrtCd: null,
        selectedQrtUnit: null
    },
    selectedUnitCode : null
};
const actions = {};
const mutations = {
    setQrtUnitAndList(state, payload) {
        if (payload !== null) {
            if (payload.selectQrtUnit !== null) {
                let selectQrtUnit = payload.selectQrtUnit;

                let type = selectQrtUnit.TYPE;
                let deptId = selectQrtUnit.DEPT_ID;
                let jobFunction = selectQrtUnit.JOB_FUNCTION;
                let finalQrtUnit = deptId + "^" + jobFunction + "^" + type;
                
                state.selectQrtInfo.selectedQrtUnit = finalQrtUnit;
                state.selectedUnit = payload.selectQrtUnit;
            }
            if (payload.selectPrevQrt !== null) {
                state.selectedPrevQrt = payload.selectPrevQrt;
                state.selectQrtInfo.selectedQrtCd = payload.selectPrevQrt.QRT_CD;
            }
        }
    },
    setUnitCode(state, payload) {
        if (payload !== null) {
            console.log("setUnitCode :: " + payload);
            state.selectedUnitCode = payload;
        }
    }
};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/module/okr/okrQrt.js